var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-seamlessan",style:(_vm.styles)},[_c('vue-seamless-scroll',{attrs:{"data":_vm.listData,"class-option":_vm.options}},[_vm._l((_vm.listData),function(item,index){return [_c('DecorationModuleCode',{key:index,attrs:{"content":_vm.detail.diy}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }